module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    staticClass: "px-2 py-4"
  }, [(_vm.loading) ? _c('v-progress-linear', {
    staticClass: "loading",
    attrs: {
      "indeterminate": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "error",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "type": "success",
      "value": true
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    attrs: {
      "required": "",
      "disabled": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }],
      "items": _vm.companies,
      "item-text": "name",
      "item-value": "id",
      "label": _vm.$lang.actions.selectCompany
    },
    model: {
      value: (_vm.selectedCompany),
      callback: function($$v) {
        _vm.selectedCompany = $$v
      },
      expression: "selectedCompany"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingRuleName)); }]
    },
    model: {
      value: (_vm.data.ruleName),
      callback: function($$v) {
        _vm.$set(_vm.data, "ruleName", $$v)
      },
      expression: "data.ruleName"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.ruleName) + " - Visible to customer"), _c('span', {
    staticClass: "error--text"
  }, [_vm._v(" *")])])], 2), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.description),
      callback: function($$v) {
        _vm.description = $$v
      },
      expression: "description"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.labels.description) + " - " + _vm._s(_vm.$lang.labels.visibleToCustomer) + "\n          ")])], 2), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$lang.header.conditions))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.amountOfPersons,
      "type": "number",
      "min": "0",
      "max": "50"
    },
    model: {
      value: (_vm.amountOfPersons),
      callback: function($$v) {
        _vm.amountOfPersons = $$v
      },
      expression: "amountOfPersons"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "multiple": "",
      "items": _vm.days,
      "clearable": ""
    },
    model: {
      value: (_vm.daysOfWeek),
      callback: function($$v) {
        _vm.daysOfWeek = $$v
      },
      expression: "daysOfWeek"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.selectDays)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v(" *")])])], 2), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "multiple": "",
      "items": _vm.types,
      "clearable": ""
    },
    model: {
      value: (_vm.orderTypes),
      callback: function($$v) {
        _vm.orderTypes = $$v
      },
      expression: "orderTypes"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.selectOrderTypes)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v(" *")])])], 2), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "multiple": "",
      "items": _vm.methods,
      "clearable": ""
    },
    model: {
      value: (_vm.paymentMethods),
      callback: function($$v) {
        _vm.paymentMethods = $$v
      },
      expression: "paymentMethods"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.selectPaymentMethods)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v(" *")])])], 2)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": "",
      "justify-space-between": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "mask": "##:##",
      "placeholder": "HH:mm",
      "rules": _vm.timeRule
    },
    model: {
      value: (_vm.startTime),
      callback: function($$v) {
        _vm.startTime = $$v
      },
      expression: "startTime"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n              " + _vm._s(_vm.$lang.labels.startTime)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v(" *")])])], 2)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "mask": "##:##",
      "placeholder": "HH:mm",
      "rules": _vm.timeRule
    },
    model: {
      value: (_vm.endTime),
      callback: function($$v) {
        _vm.endTime = $$v
      },
      expression: "endTime"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n              " + _vm._s(_vm.$lang.labels.endTime)), _c('span', {
    staticClass: "error--text"
  }, [_vm._v(" *")])])], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.minAmount,
      "type": "number",
      "max": "100",
      "min": "0"
    },
    model: {
      value: (_vm.minAmount),
      callback: function($$v) {
        _vm.minAmount = $$v
      },
      expression: "minAmount"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.voucherCode
    },
    model: {
      value: (_vm.voucherCode),
      callback: function($$v) {
        _vm.voucherCode = $$v
      },
      expression: "voucherCode"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$lang.header.values))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.discountAmount,
      "type": "number",
      "max": "100",
      "min": "0",
      "clearable": "",
      "disabled": _vm.discountPercent !== null
    },
    model: {
      value: (_vm.discountAmount),
      callback: function($$v) {
        _vm.discountAmount = $$v
      },
      expression: "discountAmount"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.discountPercent,
      "type": "number",
      "max": "100",
      "min": "0",
      "suffix": "%",
      "disabled": _vm.discountAmount !== null,
      "clearable": ""
    },
    model: {
      value: (_vm.discountPercent),
      callback: function($$v) {
        _vm.discountPercent = $$v
      },
      expression: "discountPercent"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": ""
    }
  }, [(_vm.isEdit && _vm.createdOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.createdOn),
      callback: function($$v) {
        _vm.createdOn = $$v
      },
      expression: "createdOn"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isEdit && _vm.modifiedOn) ? _c('v-text-field', {
    staticClass: "min-w max-w mx-3",
    attrs: {
      "label": _vm.$lang.labels.modified,
      "readonly": ""
    },
    model: {
      value: (_vm.modifiedOn),
      callback: function($$v) {
        _vm.modifiedOn = $$v
      },
      expression: "modifiedOn"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-space-between": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'discountRules'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v(" Close")], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.validation
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v(_vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-633f02cd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/discountRules/DiscountRuleDetails.vue
// module id = 415
// module chunks = 35